



































import BaseCmsBlock from '../../node_modules/sitis-nuxt/lib/cms/CmsBlockMixin'

export default BaseCmsBlock.extend({
  name: "FeaturesCarouselBlock",
  data() {
    return {
      swiperOptions: {
        spaceBetween: 12,
        slidesPerView: 3.1,
        slidesOffsetAfter:400,
        loop: true,
        breakpoints: {
          0: {
            slidesPerView: 1.7,
            spaceBetween: 48,
          },
          768: {},
          1000: {
            spaceBetween: 12,
            slidesPerView: 2.7
          },
          1500: {
            slidesPerView: 3.1,
          }
        },
      },
    };
  },
});
